"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var middles_1 = require("topology-core/middles");

var final_1 = require("./final");

var fork_1 = require("./fork");

var swimlaneH_1 = require("./swimlaneH");

var swimlaneV_1 = require("./swimlaneV");

function register() {
  middles_1.registerNode('activityFinal', final_1.activityFinal, null, final_1.activityFinalIconRect, final_1.activityFinalTextRect);
  middles_1.registerNode('swimlaneV', swimlaneV_1.swimlaneV, null, swimlaneV_1.swimlaneVIconRect, swimlaneV_1.swimlaneVTextRect);
  middles_1.registerNode('swimlaneH', swimlaneH_1.swimlaneH, null, swimlaneH_1.swimlaneHIconRect, swimlaneH_1.swimlaneHTextRect);
  middles_1.registerNode('forkH', fork_1.fork, fork_1.forkHAnchors, fork_1.forkIconRect, fork_1.forkTextRect);
  middles_1.registerNode('forkV', fork_1.fork, fork_1.forkVAnchors, fork_1.forkIconRect, fork_1.forkTextRect);
}

exports.register = register;